import { render, staticRenderFns } from "./number-display.vue?vue&type=template&id=3f37f69a&scoped=true&"
import script from "./number-display.vue?vue&type=script&lang=js&"
export * from "./number-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f37f69a",
  null
  
)

export default component.exports